import {TierPlan} from './payment.type';

export type ActiveOrderResponse = {
  code: number;
  data: ActiveOrder;
};

export type ActiveOrder = {
  created_at: string;
  deleted_at: string;
  files: ActiveOrderFile[];
  id: number;
  invoice_id: string;
  number: string;
  status: string;
  totalPrice: string;
  updated_at: string;
  processing?: boolean;
};

export type ActiveOrderFile = {
  completed_at: string;
  created_at: string;
  deleted_at: string;
  desc_download_url: string;
  desc_key: string;
  dist_download_url: string;
  dist_key: string;
  dist_name: string;
  hash: string;
  id: number;
  info_form_pages_count: number;
  info_pages_count: number;
  info_source_size: number;
  info_table_pages_count: string;
  price: number;
  remediation_order_id: number;
  remediation_pdf_id: number;
  source_download_url: string;
  source_key: string;
  source_name: string;
  status: string;
  updated_at: string;
  processing?: boolean;
  name?: string;
  size?: number;
};

export interface IOrderFiles {
  name?: any;
  completed_at: string;
  submitted_at: string;
  created_at: string;
  deleted_at: string;
  dist_key: string;
  dist_name: string;
  id: number;
  info_pages_count: number;
  price: number;
  remediation_order_id: number;
  source_key: string;
  source_name: string;
  status: string;
  updated_at: string;
  source_download_url: string;
  dist_download_url: string;
  dist_cdn_url: string;
  desc_download_url: string;
  info_form_pages_count: number;
  info_table_pages_count: any;
  desc_key: string;
  size?: number;
  info_source_size?: number;
  processing?: number;
  hash?: string;
  selectedRemediation?: boolean;
}

export interface ISiteFiles {
  code: number;
  data: {
    moreAvailable: boolean;
    page: number;
    perPage: number;
    total: number;
    ordersFiles: {
      count: number;
      rows: IOrderFiles[];
    };
  };
}

export interface IRemediatedSiteFiles {
  data: {
    remediationPdfs: IRemediatedFile[];
  };
}

export interface IRemediatedFile {
  createdAt: string;
  desc_download_url: string;
  desc_key: string;
  dist_download_url: string;
  dist_key: string;
  id: number;
  pdfUrl: string;
  siteRemediationId: number;
  source_download_url: string;
  source_key: string;
  source_name: string;
  status: string;
  updatedAt: string;
}

export interface ICountsFiles {
  code: number;
  data: {
    moreAvailable: boolean;
    page: number;
    perPage: number;
    total: number;
    counts: {
      remediated: number;
      sent: number;
      site: number;
      sites: ICountsFilesSite[];
      waitingPaymentOrder: number;
    };
  };
}

export interface ICountsFilesSite {
  id: number;
  host: string;
  file_count: number;
}

export enum OrderStatuses {
  NEW = 'NEW',
  SUBMITTED = 'SUBMITTED',
  PAID = 'PAID',
  DONE = 'DONE',
  WAITING_FOR_PAYMENT = 'WAITING_FOR_PAYMENT',
  AUTO_REMEDIATION = 'AUTO_REMEDIATION',
  COMPLETED = 'COMPLETED',
  UPLOADING = 'UPLOADING',
  FAILED = 'FAILED',
}

export enum FileStatuses {
  NEW = 'NEW',
  SUBMITTED = 'SUBMITTED',
  PAID = 'PAID',
  DONE = 'DONE',
  WAITING_FOR_PAYMENT = 'WAITING_FOR_PAYMENT',
  AUTO_REMEDIATION = 'AUTO_REMEDIATION',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  ERROR = 'ERROR',
  FAILED = 'FAILED',
}

export enum FileStatusesRequest {
  deployed = 'deployed',
  accessible = 'accessible',
  inaccessible = 'inaccessible',
  waiting_for_payment = 'waiting_for_payment',
  auto_remediation = 'auto_remediation',
  done = 'done',
  new = 'new',
  enqueued = 'enqueued',
  submitted = 'submitted',
  paid = 'paid',
  error = 'error',
  processing = 'processing',
  completed = 'completed',
  failed = 'failed',
}

export enum UiFileStatusesDropdown {
  accessible = 'accessible',
  waiting_for_payment = 'awaiting payment',
  all = 'all statuses',
}

export interface ICreateInstance {
  paymentType: string;
  amount: string;
  pdfRemediationOrderId: number;
}

export type PdfRemediationStatsDto = {
  total: number;
  accessible: number;
  inaccessible: number;
};

export interface CreateAutoRemediationOrderResponseDto {
  id: number;
  number: string;
  status: OrderStatuses;
  createdAt?: Date | null;
  updatedAt?: Date | null;
}

export enum RemediationSubmissionState {
  SELECT_SITES = 'SELECT_SITES',
  SELECT_SITES_AND_PLAN = 'SELECT_SITES_AND_PLAN',
  SELECT_NEW_PLAN = 'SELECT_NEW_PLAN',
  UPGRADE_PLAN = 'UPGRADE_PLAN',
  COMPLETE_PAYMENT = 'COMPLETE_PAYMENT',
  CONFIRM_REMEDIATION = 'CONFIRM_REMEDIATION',
  REMEDIATION_STARTED = 'REMEDIATION_STARTED',
  REMEDIATION_NOT_CONFIRMED = 'REMEDIATION_NOT_CONFIRMED',
  PAYMENT_FAILED = 'PAYMENT_FAILED',
}

export interface AutoRemediationInitResponse {
  quota: {
    created_at: string;
    id: number;
    is_enabled: boolean;
    is_renewable: boolean;
    pricing_tier: TierPlan;
    total_quota: number;
    updated_at: string;
    used_quota: number;
  };
  state: RemediationSubmissionState;
}

export type UpgradeTiers = {
  name: string;
  quota: number;
};
